import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import "./style.css";

const Static = ({ data }) => {
	const lang = useSelector((state) => state.lang.lang);

	return (
		<div className="main-page">
			<div className="static">
				<div className="container">
					<div className="about">
						{data[0]?.about_us_values?.map((res, index) => {
							return (
								<div
									className={`about-card mb-4 ${
										index % 2 === 0 ? "one" : "two"
									}`}>
									{index % 2 === 0 ? (
										<>
											<motion.img
												initial={{ opacity: 0, y: 50 }}
												animate={{ opacity: 1, y: 0 }}
												whileHover={{ scale: 1.1 }}
												whileTap={{ scale: 0.95 }}
												src={res?.image}
												alt="about"
											/>
											<div className="details">
												<p
													className="details-title"
													dangerouslySetInnerHTML={{
														__html: res[`title_${lang}`],
													}}></p>
												<p
													className="details-description"
													dangerouslySetInnerHTML={{
														__html: res[`description_${lang}`],
													}}></p>
											</div>
										</>
									) : (
										<>
											<div className="details">
												<p
													className="details-title"
													dangerouslySetInnerHTML={{
														__html: res[`title_${lang}`],
													}}></p>
												<p
													className="details-description"
													dangerouslySetInnerHTML={{
														__html: res[`description_${lang}`],
													}}></p>
											</div>
											<motion.img
												initial={{ opacity: 0, y: 50 }}
												animate={{ opacity: 1, y: 0 }}
												whileHover={{ scale: 1.1 }}
												whileTap={{ scale: 0.95 }}
												src={res?.image}
												alt="about"
											/>
										</>
									)}
								</div>
							);
						})}
						{/* <div className="about-card one mb-4" data-aos="zoom-in">
								<img src={bg} alt="about" />
							</div>
							<div className="about-card two" data-aos="zoom-in">
								<div className="details">
									<p className="details-title">{t("Our Mission")}</p>
									<p className="details-description">
										It is a long established fact that a reader will be
										distracted by the readable content of a page when looking at
										its layout. The point of using Lorem Ipsum is that it has a
										more-or-less normal distribution of letters, as opposed to
										using 'Content here, content here', making it look like
										readable English. Many desktop publishing packages and web
										page editors now use Lorem Ipsum as their default model
										text, and a search for 'lorem ipsum' will uncover many web
										sites still in their infancy. Various versions have evolved
										over the years, sometimes by accident, sometimes on purpose
										(injected humour and the like).
									</p>
								</div>
								<img src={bg} alt="about" />
							</div> */}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Static;
